import { createMapRegistry } from './create-registry'

export const constantsRegistry = createMapRegistry<unknown>('ConstantsRegistry')
